import client from 'helpers/client';
import mvpAuth from "helpers/mvpAuth";
export default class UploadImageAdapterPlugin {
  constructor(props) {
    this.loader = props;
  }

  upload() {
    return new Promise((resolve, reject) =>
      this.loader.file.then((file) => {
        let authorization = mvpAuth.getHeaderForMvp()
        let formData = new FormData();
        formData.append('image', file)
        return client.sendRequest({
          path: 'mvp/upload-file',
          method: 'POST',
          params: formData,
          headers: {
            'content-type': 'multipart/form-data',
            'authorization': authorization.authorization
          },
        }).then((response) => {
          console.log('response?.data', response?.data)
          resolve({ default: response?.data });
        }).catch((err) => {
          reject(err)
        });
      }),
    );
  }
}
